const hcEscape = (value) => {
  const v = value == null ? '' : String(value)
  if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(v)
  return v.replace(/["\\#.;:,[\]()=>+*~^$|!?{}]/g, '\\$&')
}

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.url = this.dataset.url || ''
    this.intent = this.dataset.intent || ''
    this.currentProductId = (this.dataset.productId || '').toString()
    this.placeholder = this.querySelector('.product-recommendations-placeholder')

    if (!this.url) return

    if (this.intent && !this.url.includes('intent=')) {
      this.url += (this.url.includes('?') ? '&' : '?') + 'intent=' + encodeURIComponent(this.intent)
    }

    if (this.placeholder) {
      this.placeholder.setAttribute('aria-hidden', 'true')
      this.placeholder.style.display = 'none'
    }

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text

        const root =
          html.querySelector(`product-recommendations#${hcEscape(this.id)}`) ||
          html.querySelector('product-recommendations') ||
          html

        const source = root.querySelector('.product-recommendations') || root

        const grid =
          source.classList && (source.classList.contains('product-grid') || source.classList.contains('new-grid'))
            ? source
            : source.querySelector('.product-grid, .new-grid')

        if (!grid) {
          if (this.placeholder) this.placeholder.remove()
          return
        }

        const gridClone = grid.cloneNode(true)

        if (this.currentProductId) {
          gridClone
            .querySelectorAll(`.product-grid-item[data-product-id="${hcEscape(this.currentProductId)}"]`)
            .forEach((el) => {
              const item =
                el.closest('.grid-item') ||
                el.closest('.grid-product') ||
                el.closest('[data-product-grid-item]') ||
                el
              item.remove()
            })
        }

        const remaining = gridClone.querySelectorAll('.product-grid-item').length
        if (!remaining) {
          if (this.placeholder) this.placeholder.remove()
          return
        }

        if (this.placeholder) {
          this.placeholder.replaceWith(gridClone)
          this.placeholder = null
          return
        }

        const target =
          this.querySelector('.product-recommendations') ||
          this.querySelector('.page-width--flush-small') ||
          this

        target.appendChild(gridClone)
        console.log('testik!!!!!!!!!!!!!!!!!!')
      })
      .catch(() => {
        if (this.placeholder) this.placeholder.remove()
      })
      .finally(() => {
        if (frcp && frcp.wishlist) frcp.wishlist.attachOnCollection()
      })
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations)
}
